// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) { return "static/js/" + "pt-BR-json" + "." + "b5d17b38" + ".chunk.js"; };